// ** Theme Config Imports
import themeConfig from '../../config';

const Button = () => {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 50,
          padding: '6px 20px',
          '&.Mui-disabled .key-shortcut': {
            opacity: 0.26,
          },
          '&.MuiButton-loading .key-shortcut': {
            opacity: 0,
          },
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: themeConfig.config.disableRipple,
      },
    },
    MuiIconButton: {
      styleOverrides: {
        padding: '9px',
      },
    },
  };
};

export default Button;
